export default {
  header: "Profile Settings",
  view: "profile",
  username: "Guest",
  date: new Date()
};
